/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PremiumScheduleAllocationDto } from './PremiumScheduleAllocationDto';
import {
    PremiumScheduleAllocationDtoFromJSON,
    PremiumScheduleAllocationDtoFromJSONTyped,
    PremiumScheduleAllocationDtoToJSON,
    PremiumScheduleAllocationDtoToJSONTyped,
} from './PremiumScheduleAllocationDto';
import type { SyncReceiptSettlementExchangeRatePayloadDto } from './SyncReceiptSettlementExchangeRatePayloadDto';
import {
    SyncReceiptSettlementExchangeRatePayloadDtoFromJSON,
    SyncReceiptSettlementExchangeRatePayloadDtoFromJSONTyped,
    SyncReceiptSettlementExchangeRatePayloadDtoToJSON,
    SyncReceiptSettlementExchangeRatePayloadDtoToJSONTyped,
} from './SyncReceiptSettlementExchangeRatePayloadDto';

/**
 * 
 * @export
 * @interface CreateReceiptPayloadDto
 */
export interface CreateReceiptPayloadDto {
    /**
     * Transaction date
     * @type {Date}
     * @memberof CreateReceiptPayloadDto
     */
    transactionDate: Date;
    /**
     * Type of receipt
     * @type {string}
     * @memberof CreateReceiptPayloadDto
     */
    receiptType: CreateReceiptPayloadDtoReceiptTypeEnum;
    /**
     * Bank account number
     * @type {string}
     * @memberof CreateReceiptPayloadDto
     */
    bankAccountNumber: string;
    /**
     * Receipt amount
     * @type {string}
     * @memberof CreateReceiptPayloadDto
     */
    amount: string;
    /**
     * Bank fee
     * @type {string}
     * @memberof CreateReceiptPayloadDto
     */
    bankFee?: string;
    /**
     * Source broker ID
     * @type {string}
     * @memberof CreateReceiptPayloadDto
     */
    sourceBrokerId: string;
    /**
     * Free-text input for broker reference
     * @type {string}
     * @memberof CreateReceiptPayloadDto
     */
    sourceBrokerReference?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReceiptPayloadDto
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateReceiptPayloadDto
     */
    comment?: string;
    /**
     * Premium schedule allocations
     * @type {Array<PremiumScheduleAllocationDto>}
     * @memberof CreateReceiptPayloadDto
     */
    premiumScheduleAllocations?: Array<PremiumScheduleAllocationDto>;
    /**
     * Receipt settlement exchange rates
     * @type {Array<SyncReceiptSettlementExchangeRatePayloadDto>}
     * @memberof CreateReceiptPayloadDto
     */
    receiptSettlementExchangeRates?: Array<SyncReceiptSettlementExchangeRatePayloadDto>;
}


/**
 * @export
 */
export const CreateReceiptPayloadDtoReceiptTypeEnum = {
    Premium: 'Premium',
    Claims: 'Claims',
    Other: 'Other'
} as const;
export type CreateReceiptPayloadDtoReceiptTypeEnum = typeof CreateReceiptPayloadDtoReceiptTypeEnum[keyof typeof CreateReceiptPayloadDtoReceiptTypeEnum];


/**
 * Check if a given object implements the CreateReceiptPayloadDto interface.
 */
export function instanceOfCreateReceiptPayloadDto(value: object): value is CreateReceiptPayloadDto {
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('receiptType' in value) || value['receiptType'] === undefined) return false;
    if (!('bankAccountNumber' in value) || value['bankAccountNumber'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('sourceBrokerId' in value) || value['sourceBrokerId'] === undefined) return false;
    return true;
}

export function CreateReceiptPayloadDtoFromJSON(json: any): CreateReceiptPayloadDto {
    return CreateReceiptPayloadDtoFromJSONTyped(json, false);
}

export function CreateReceiptPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReceiptPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionDate': (new Date(json['transactionDate'])),
        'receiptType': json['receiptType'],
        'bankAccountNumber': json['bankAccountNumber'],
        'amount': json['amount'],
        'bankFee': json['bankFee'] == null ? undefined : json['bankFee'],
        'sourceBrokerId': json['sourceBrokerId'],
        'sourceBrokerReference': json['sourceBrokerReference'] == null ? undefined : json['sourceBrokerReference'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'premiumScheduleAllocations': json['premiumScheduleAllocations'] == null ? undefined : ((json['premiumScheduleAllocations'] as Array<any>).map(PremiumScheduleAllocationDtoFromJSON)),
        'receiptSettlementExchangeRates': json['receiptSettlementExchangeRates'] == null ? undefined : ((json['receiptSettlementExchangeRates'] as Array<any>).map(SyncReceiptSettlementExchangeRatePayloadDtoFromJSON)),
    };
}

export function CreateReceiptPayloadDtoToJSON(json: any): CreateReceiptPayloadDto {
    return CreateReceiptPayloadDtoToJSONTyped(json, false);
}

export function CreateReceiptPayloadDtoToJSONTyped(value?: CreateReceiptPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionDate': ((value['transactionDate']).toISOString()),
        'receiptType': value['receiptType'],
        'bankAccountNumber': value['bankAccountNumber'],
        'amount': value['amount'],
        'bankFee': value['bankFee'],
        'sourceBrokerId': value['sourceBrokerId'],
        'sourceBrokerReference': value['sourceBrokerReference'],
        'fileIds': value['fileIds'],
        'comment': value['comment'],
        'premiumScheduleAllocations': value['premiumScheduleAllocations'] == null ? undefined : ((value['premiumScheduleAllocations'] as Array<any>).map(PremiumScheduleAllocationDtoToJSON)),
        'receiptSettlementExchangeRates': value['receiptSettlementExchangeRates'] == null ? undefined : ((value['receiptSettlementExchangeRates'] as Array<any>).map(SyncReceiptSettlementExchangeRatePayloadDtoToJSON)),
    };
}

